import * as React from "react"

export default () => <div>Not found</div>
